// Shared styling for the app's rsuite data tables (DevicesTable, FaultsTable),
// bringing them closer to the pre-pivot Cloudscape look. Pair with dataTable.css
// (compact density, header column separators, zebra striping) via
// className="data-table" on the <Table>.

// Darker header text than rsuite's default (--rs-text-primary), closer to
// Cloudscape's near-black column headers.
export const HEADER_STYLE = { fontWeight: 'bold', fontSize: 14, color: '#1f2937' };

// A cell whose content is a custom element (not a bare rsuite dataKey string)
// needs these explicitly: rsuite only ellipsizes plain text, and verticalAlign
// turns the cell content into a flex container (which defeats the cell's own
// text-overflow), so each text span must clip/ellipsize itself and carry
// min-width:0 so it can shrink below its content width instead of widening the row.
export const ELLIPSIS_STYLE = { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 };

// rsuite Table rowClassName: shade every 2nd row (zebra), matching Cloudscape's
// stripedRows. See dataTable.css for the .data-table-striped rule.
export const stripedRowClassName = (_rowData, rowIndex) => (rowIndex % 2 === 1 ? 'data-table-striped' : '');
